module.exports = __webpack_public_path__ + "img/logo-light.49b9bcd4.svg";